import React, { useEffect, useState, useRef } from 'react';
import SendEmail from '../Icons/Send_email.png';
import request from '../services/Request';
import 'react-simple-keyboard/build/css/index.css';
import KeyBoard from './items/keyboard';
import { useTranslation } from 'react-i18next';

export default function EnterEmail(props) {
  const { t } = useTranslation();
  // const [title, setTitle] = useState('No');
  const [error, setError] = useState('');

  const keyboard = useRef();

  const { receipt, readySend, show, setShow, receiptSend, setReceiptSend, setInput, input } = props;

  const emailPattern = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$');

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setInput('');
    setShow(true);
  };

  useEffect(() => {
    if (input === '') {
      setError('');
      // setTitle('No');
    } else if (emailPattern.test(input)) {
      // setTitle('Yes, send email');
      setError('');
    } else {
      // setTitle('Yes, send email');
      setError('Please enter valid email address');
    }
  }, [input]);

  // useEffect(async () => {
  //   if (readySend && receiptSend) {
  //     const SENDEMAIL = '/receipt/send';
  //     const EMAILCODE = '/promos/emailCode';
  //     if (input !== '' && error === '') {
  //       if (separateItem?.length > 0) {
  //         setTimeout(() => {
  //           request({
  //             method: 'post',
  //             url: SENDEMAIL,
  //             data: {
  //               orderID: orderID,
  //               email: input,
  //               receipt: machine.receipt,
  //             },
  //           })
  //             .then(() => {})
  //             .catch((e) => {
  //               console.log(e);
  //             });
  //         }, 5000);
  //         const data = [];
  //         const oneTime = JSON.parse(localStorage.getItem('oneTime'));
  //         if (!oneTime) {
  //           console.log('inn');
  //           separateItem.forEach((e) => {
  //             if (e.emailCode) {
  //               data.push({
  //                 promo: e.promo,
  //                 name: e.product_name,
  //                 upc: e.upc,
  //                 _id: e.product,
  //                 email: input,
  //               });
  //             }
  //           });
  //         }
  //         if (data.length > 0) {
  //           request({
  //             method: 'post',
  //             url: EMAILCODE,
  //             data: {
  //               orderID: orderID,
  //               data: data,
  //             },
  //           })
  //             .then(() => {})
  //             .catch((e) => {
  //               console.log(e);
  //             });
  //         }
  //       }
  //     }
  //   }
  // }, [readySend, receiptSend]);

  if (receipt !== '' && receipt !== undefined && receipt !== null) {
    return (
      <div className="">
        <div className="d-flex justify-content-center">
          <img
            style={{
              marginTop: '100px',
              marginBottom: '30px',
              maxHeight: '100px',
            }}
            src={SendEmail}
            alt="send_email"
          />
        </div>
        {receiptSend ? (
          readySend ? (
            <span
              style={{
                fontSize: '45px',
              }}
              className="cat-title"
            >
              {t(`Receipt delivering.`)}
            </span>
          ) : (
            <span
              style={{
                fontSize: '45px',
              }}
              className="cat-title"
            >
              {t(`Receipt delivering.`)}
            </span>
          )
        ) : (
          <div>
            <div
              style={{
                flexDirection: 'column',
                alignItems: 'center',
              }}
              className="d-flex justify-content-center"
            >
              <span
                style={{
                  fontSize: '50px',
                }}
                className="cat-title"
              >
                Do you want an email receipt?
              </span>
              <span
                style={{
                  fontSize: '45px',
                }}
                className="cat-title"
              >
                Please enter your email below
              </span>
            </div>

            <div
              style={{
                flexDirection: 'column',
                alignItems: 'center',
              }}
              className="d-flex justify-content-center mt-4"
            >
              <input
                id="myinput2"
                type="email"
                placeholder="Email"
                value={input}
                onClick={handleShow}
                onChange={onChangeInput}
                aria-label="Search"
                className="search-form mb-3"
              />
              {error !== '' && <p style={{ color: 'red', fontSize: '30px' }}>{error}</p>}

              <KeyBoard
                setError={setError}
                show={show}
                error={error}
                handleClose={handleClose}
                input={input}
                setInput={setInput}
                keyboard={keyboard}
                setShow={setShow}
                send={true}
                setReceiptSend={setReceiptSend}
              />
              {/* <div className="d-flex">
          <button type="button" className="cart-checkout-button" onClick={sendEmail}>
            {title}
          </button>
        </div> */}
            </div>
          </div>
        )}
      </div>
    );
  } else return null;
}
